import {getEnglishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Valuta l\'articolo',
    message: 'Voto espresso',
    votes: votes => `${getEnglishPlurals(["opinione", "opinioni"], +votes)},`,
    score: 'valutazione'
  },
  feedback: {
    label: 'Questo articolo è stato utile?'
  }
};